import script from "./LaserHarp.vue?vue&type=script&setup=true&lang=js"
export * from "./LaserHarp.vue?vue&type=script&setup=true&lang=js"

import "./LaserHarp.vue?vue&type=style&index=0&id=a50d0220&scoped=true&lang=css"

import exportComponent from "/Users/amon/works/laserharp-player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a50d0220"]])

export default __exports__